<template>
	<div>
		<table-run
			v-bind:columns="columns"
			v-bind:rows="rows"
			v-bind:selectable="false"
			v-bind:include-delete="false"
			v-bind:include-export-to-excel="false"
			v-bind:include-options="true"
			v-bind:include-switch="false"
			v-bind:include-settings="false"
			v-bind:include-delete-single="false"
			v-on:on-sortable-event="columnSortableEvent"
			v-on:on-search-event="searchByColumn"
			class="no-search-table no-selectable-table table-custom-options">
			<template slot="rows" scope="props">
				<td>{{ props.row.number }}</td>
				<td>{{ props.row.createdAt | parseDate('DD/MM/YYYY HH:mm:ss') }}</td>
				<td>{{ props.row.status | statusName }}</td>
				<td>{{ props.row.cancelDate | parseDate('DD/MM/YYYY HH:mm:ss') }}</td>
				<td>{{ props.row.warehouse.name }}</td>
				<td class="text-xs-right pr-2 options-column options-column-transfers"
					:class="{ 'active': props.row.classActive }">
					<span class="options-item">
						<v-icon class="settings-icon material-icons icon" v-on:click.stop="openDialog(props.row)">list</v-icon>
					</span>
					<div class="undo-item">
						<v-icon
							v-if="props.row.showUndo"
							v-on:click.stop="setDialogState(props.row.id, true)"
							class="undo-icon">
							undo
						</v-icon>
					</div>
					<v-dialog v-model="props.row.dialog" width="351">
						<v-card>
							<v-card-title class="headline pb-0">¿Está seguro de anular la transacción #{{ props.row.number }}?</v-card-title>
							<v-card-text class="pt-0">*Este proceso es irreversible</v-card-text>
							<v-card-actions class="pb-3">
								<v-btn class="btn-save mr-2" @click.native="setDialogState(props.row.id, false)">No anular</v-btn>
								<v-btn class="btn-cancel ml-2" @click.native="undoTransfer(props.row)">Anular</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</td>
			</template>
		</table-run>
		<v-layout row wrap justify-end mt-3 v-show="totalPages">
			<v-pagination
				:length="totalPages"
				:total-visible="pagesVisible"
				v-model="page"
				v-on:input="changePage"></v-pagination>
		</v-layout>
		<v-dialog v-model="dialog" width="700">
			<v-card class="pb-4 px-3">
				<v-card-title class="headline px-0" v-if="transferSelected">
					La transferencia #{{ transferSelected.number }} se realizó en la fecha {{ transferSelected.createdAt | parseDate }}
					al minibar: {{ transferSelected.warehouse.name }}
					<v-icon class="close-modal" v-on:click.stop="closeModal">cancel</v-icon>
					<span v-if="transferSelected.cancelDate">
						Transferencia anulada el día {{ transferSelected.cancelDate | parseDate }}
					</span>
				</v-card-title>
				<list-of-details
					:columns="columnsToDetails"
					:rows="modalData"
					v-on:sortable-list-detail="sortableDetail"
					v-on:search-list-detail="searchOnDetail">
				</list-of-details>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import TableRun from 'table-run';
	import mixin from '@/shared/mixins';
	import { parseDate } from '@/shared/filters';
	import ListOfDetails from '@/components/shared/ListOfDetails';

	function created() {
		this.loadData();
	}

	async function changePage(value) {
		this.page = value;
		this.loadData();
	}

	function closeModal() {
		this.transferSelected = null;
		this.modalData = [];
		this.sortDirectionToDetail = null;
		this.sortFieldToDetail = null;
		this.searchToDetail = null;
		this.dialog = false;
	}

	function columnSortableEvent({ id }) {
		const self = this;
		const newColumn = self.columns.filter(column => column.id === id);
		newColumn[0].isSortable = newColumn[0].isSortable.down ?
			{ down: false, up: true } : { down: true, up: false };
		self.columns = self.columns.map((columnSingle) => {
			const newColumnSingle = Object.assign({}, columnSingle);
			if ((columnSingle.id !== newColumn[0].id) && columnSingle.isSortable) {
				newColumnSingle.isSortable = { down: true, up: false };
			}
			return newColumnSingle;
		});
		this.sortField = newColumn[0].code;
		this.sortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
		this.loadData();
	}

	async function loadData() {
		const params = {
			limit: this.limit,
			page: this.page,
		};
		if (this.search) {
			params.search = this.search;
		}
		if (this.sortField) {
			params.sortField = this.sortField;
		}
		if (this.sortDirection) {
			params.sortDirection = this.sortDirection;
		}
		const response = await this.$http.get(`${process.env.PRODUCTS_URL}/p/transfers-minibar`, { params });
		this.totalPages = Number(response.headers.get('x-last-page'));
		this.rows = response.data.map((data) => {
			const newData = Object.assign({}, data);
			newData.showUndo = true;
			newData.dialog = false;
			if (data.cancelUserId) {
				newData.showUndo = false;
			}
			return newData;
		});
	}

	async function loadModalData({ id }) {
		const params = {};
		if (this.searchToDetail) {
			params.search = this.searchToDetail;
		}
		if (this.sortDirectionToDetail) {
			params.sortDirection = this.sortDirectionToDetail;
		}
		if (this.sortFieldToDetail) {
			params.sortField = this.sortFieldToDetail;
		}
		const response = await this.$http.get(`${process.env.PRODUCTS_URL}/p/transfers/${id}/minibar`, { params });
		this.modalData = response.data;
	}

	function openDialog(transfer) {
		this.transferSelected = transfer;
		this.loadModalData(transfer);
		this.dialog = true;
	}

	function pagesVisible() {
		return this.totalPages < 5 ? this.totalPages : 5;
	}

	function searchByColumn(search) {
		this.search = search;
		this.page = 1;
		this.loadData();
	}

	function searchOnDetail(search) {
		this.searchToDetail = search;
		this.loadModalData(this.transferSelected);
	}

	function setDialogState(id, state) {
		this.rows = this.rows.map((row) => {
			const newRow = Object.assign({}, row);
			if (row.id === id) {
				newRow.dialog = state;
			}
			return newRow;
		});
	}

	function sortableDetail(id) {
		const self = this;
		const newColumn = self.columnsToDetails.filter(column => column.id === id);
		newColumn[0].isSortable = newColumn[0].isSortable.down ?
			{ down: false, up: true } : { down: true, up: false };
		self.columnsToDetails = self.columnsToDetails.map((columnSingle) => {
			const newColumnSingle = Object.assign({}, columnSingle);
			if ((columnSingle.id !== newColumn[0].id) && columnSingle.isSortable) {
				newColumnSingle.isSortable = { down: true, up: false };
			}
			return newColumnSingle;
		});
		this.sortDirectionToDetail = newColumn[0].isSortable.up ? 'asc' : 'desc';
		this.sortFieldToDetail = newColumn[0].code;
		this.loadModalData(this.transferSelected);
	}

	function statusName(value) {
		let name = 'Pendiente';
		switch (value) {
		case 1:
			name = 'Pendiente';
			break;
		case 2:
			name = 'En Transcurso';
			break;
		case 3:
			name = 'Finalizado';
			break;
		default:
			name = '';
			break;
		}
		return name;
	}

	async function undoTransfer({ id, number }) {
		await this.$http.patch(`${process.env.PRODUCTS_URL}/p/transfers/${id}/cancel`);
		this.showNotification(`La transferencia #${number} ha sido anulada.`, 'success');
		this.loadData();
	}

	export default {
		components: {
			ListOfDetails,
			TableRun,
		},
		computed: {
			pagesVisible,
		},
		created,
		data() {
			return {
				columns: [
					{ id: 1, name: '# Transferencia', code: 'number', isSortable: { down: true, up: false } },
					{ id: 2, name: 'Fecha', code: 'created_at', isSortable: { down: true, up: false } },
					{ id: 3, name: 'Estado', code: 'status', isSortable: { down: true, up: false } },
					{ id: 4, name: 'Fecha de anulación', code: 'cancel_date', isSortable: { down: true, up: false } },
					{ id: 5, name: 'Minibar', code: 'w.name' },
				],
				columnsToDetails: [
					{ id: 1, name: 'Nombre de producto', code: 'name', isSortable: { down: true, up: false } },
					{ id: 2, name: 'Precio', code: 'price', isSortable: { down: true, up: false } },
					{ id: 3, name: 'Cantidad', code: 'quantity', isSortable: { down: true, up: false } },
				],
				dialog: false,
				limit: 10,
				modalData: [],
				page: 1,
				rows: [],
				search: null,
				searchToDetail: null,
				sortDirection: null,
				sortDirectionToDetail: null,
				sortField: null,
				sortFieldToDetail: null,
				totalPages: 5,
				transferSelected: null,
			};
		},
		filters: {
			parseDate,
			statusName,
		},
		methods: {
			changePage,
			closeModal,
			columnSortableEvent,
			loadData,
			loadModalData,
			openDialog,
			searchByColumn,
			searchOnDetail,
			setDialogState,
			sortableDetail,
			undoTransfer,
		},
		mixins: mixin,
		name: 'transfers',
	};
</script>

<style lang="scss" scoped>
	.options-column {
		display: none;

		&.options-column-transfers {
			display: flex !important;
			justify-content: flex-end;

			span {
				display: inline-flex;
			}

			.settings-icon {
				color: map-get($colors, blue-title);
				cursor: pointer;
				font-size: map-get($sizes, twenty);
			}

			.undo-item {
				cursor: pointer;
				height: 10px;
				line-height: 12px;
				margin-left: 15px;
				margin-right: 10px;
				width: 20px;
			}

			.undo-icon {
				height: 10px;
			}

			img {
				height: 15px;
			}
		}
	}

	.headline {
		font-size: map-get($sizes, eighteen) !important;

		span {
			color: red;
			font-size: map-get($sizes, fourteen);
		}
	}

	.card__text {
		color: red;
		font-size: map-get($sizes, sixteen);
		text-align: left;
	}

	.card__actions {
		justify-content: center;
	}
</style>



// WEBPACK FOOTER //
// List.vue?4064ccb9